
export const TAGS = {
    NEWS_COUNT: 'news-count'
};
